const CALENDAR_OVERALL_ID = "cc-calendar-overall";
const DELIVERY_DATEPICKER_ID = "cart-cc-delivery_datepicker";
const SPECIFIED_RADIO_ID = "cc-delivery-specified";
const UNSPECIFIED_RADIO_ID = "cc-delivery-unspecified";

// 日付指定アプリの読み込むタイミングの関係で、
// DOM の変更を監視する MutationObserver を利用してイベントの設定を行う
var observer = new MutationObserver(onMutation);
observer.observe(document.body, { childList: true, subtree: true });

function onMutation(mutationsList, _) {
  for (let mutation of mutationsList) {
    if (mutation.type === "childList") {
      for (let node of mutation.addedNodes) {
        // 日付指定アプリが描画されたら初回表示の設定等を行う
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          node.id === CALENDAR_OVERALL_ID
        ) {
          const datePickerElement = document.getElementById(
            DELIVERY_DATEPICKER_ID
          );
          if (!datePickerElement) {
            return;
          }
          setupCalendarEventListeners(datePickerElement);
          resetCalendarInputs(datePickerElement);
          observer.disconnect();
        }
      }
    }
  }
}

// 日付指定アプリの親要素に要素にイベントリスナーを設定する関数
function setupCalendarEventListeners(datePickerElement) {
  var specifiedRadio = document.getElementById(SPECIFIED_RADIO_ID);
  var unspecifiedRadio = document.getElementById(UNSPECIFIED_RADIO_ID);

  // 「指定する」ラジオボタンのイベントハンドラ
  specifiedRadio.addEventListener("change", function () {
    toggleCalendarVisibility(datePickerElement, specifiedRadio.checked);
  });

  // 「指定しない」ラジオボタンのイベントハンドラ
  unspecifiedRadio.addEventListener("change", function () {
    resetCalendarInputs(datePickerElement);
    toggleCalendarVisibility(datePickerElement, !unspecifiedRadio.checked);
  });
}

// 日付指定アプリの親要素の表示状態を切り替える関数
function toggleCalendarVisibility(datePickerElement, isVisible) {
  if (isVisible) {
    datePickerElement.style.display = "block";
  } else {
    datePickerElement.style.display = "none";
  }
}

// 日付指定アプリ内の入力をリセットする関数
function resetCalendarInputs(datePickerElement) {
  var inputs = datePickerElement.querySelectorAll("input");
  inputs.forEach(function (input) {
    input.value = "指定しない";
  });

  var selects = datePickerElement.querySelectorAll("select");
  selects.forEach(function (select) {
    select.selectedIndex = 0;
  });
}
